import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'
import { v4 as uuidv4 } from 'uuid'

export type SeverityType = 'info' | 'success' | 'error'

export type NotificationType = {
  message: string
  severity: SeverityType
  id?: number
}

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  $notificationSubj = new Subject<NotificationType>()

  constructor() {}

  notify(notification: NotificationType) {
    const notify = { ...notification, id: uuidv4() }
    this.$notificationSubj.next(notify)
  }

  handleError(message: string) {
    this.notify({ severity: 'error', message: message ? message : 'Unknown error' })
  }

  handleSuccess(message: string) {
    this.notify({ severity: 'success', message })
  }

  handleInfo(message: string) {
    this.notify({ severity: 'info', message })
  }
}
